import { isAlwaysAvailablePage, type NavigationSchema } from '../schemas/navigation';
import type { PageSchema } from '../schemas/page';

export function isMainHomeUrl(url: string): boolean {
  return url.split(/[?#]/, 1)[0].replace(/\/$/, '') === '/main/home';
}

export function idleTransitionNavigation(idle: boolean, tabBarEnabled: boolean, url: string): 'home' | 'legacy-wake' | undefined {
  if (idle) return isMainHomeUrl(url) ? undefined : 'home';
  return tabBarEnabled && isMainHomeUrl(url) ? 'legacy-wake' : undefined;
}

export function resolveIdleTapPageId(
  navigation: NavigationSchema | undefined, pages: readonly Pick<PageSchema, 'id' | 'availability'>[], url: string,
): string | undefined {
  if (navigation?.tabBar.enabled !== false || !isMainHomeUrl(url)) return undefined;
  const action = navigation.idleTapAction;
  const page = action?.type === 'page' ? pages.find(page => page.id === action.pageId) : undefined;
  return page && isAlwaysAvailablePage(page) ? page.id : undefined;
}
